import { render, staticRenderFns } from "./treatmentInfo.vue?vue&type=template&id=a2cc672e&scoped=true"
import script from "./treatmentInfo.vue?vue&type=script&lang=js"
export * from "./treatmentInfo.vue?vue&type=script&lang=js"
import style0 from "./treatmentInfo.vue?vue&type=style&index=0&id=a2cc672e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cc672e",
  null
  
)

export default component.exports